export const MODULE_CONSTANTS = {
  CLIENTS: {
    CUSTOMER: "Customer",
    CUSTOMER_USER: "Customer User",
  },
  WORKFORCE: {
    MANAGER: "Manager",
    ADMIN: "Admin",
    SUBCONTRACTOR: "Subcontractor",
    EMPLOYEE: "Employee",
  },
  ROSTER: {
    FLEET: "Roster Fleet",
    DAILY_REPORT: "Roster Daily Report",
  },
  REPORT: {
    TIPPING_REPORT: "Tipping Report",
    DAILY_REPORT: "Daily Report",
    SUPERVISOR_REPORT: "SupervisorReports",
  },
  TIMESHEET: "Timesheet",
  TASK_CLAIMS: "Task & Claims",
  PROJECT_REGISTER: "Project Register",
  PROJECT: "Project",
  CUSTOMER_PORTAL: {
    USER_MANAGEMENT: "User Management",
  },
  INVOICING: {
    XERO: "Xero Invoice",
  },
  MAINTENANCE: "Maintenance",
} as const;
